<template>
	<div>
		<el-card shadow="never">
			<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
				<el-form-item label="用户昵称：">
					<el-input v-model="dataForm.name" placeholder="请输入" clearable suffix-icon="el-icon-search">
					</el-input>
				</el-form-item>
				<el-form-item label="手机号：">
					<el-input v-model="dataForm.phone" placeholder="请输入" clearable suffix-icon="el-icon-search">
					</el-input>
				</el-form-item>
				<el-form-item label="会员等级：">
					<el-select multiple v-model="dataForm.member_uuid" placeholder="请选择">
						<el-option v-for="item in level" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="注册时间：">
					<el-date-picker @change="changeTime" format="yyyy-MM-dd HH:mm" value-format='yyyy-MM-dd HH:mm'
						v-model="dataForm.registerTime" type="datetimerange" start-placeholder="开始日期"
						end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="用户状态：">
					<el-select v-model="dataForm.disabled" placeholder="请选择">
						<el-option v-for="item in userStatuList" :key="item.value" :label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="network().getUserTableList()">搜索</el-button>
					<el-button @click="event().clearSearch()">重置</el-button>
				</el-form-item>
				<!-- <el-form-item style="float: right;">
			    <el-button type="primary" @click="network().downloadUserTableExcel()">导出</el-button>
			  </el-form-item> -->
			</el-form>
		</el-card>
		<el-card shadow="never" style="margin-top: 30px;">
			<el-form :inline='true'>
				<el-form-item>
					<el-button type="primary" @click="addAdminClick('新增')">新增用户
					</el-button>
				</el-form-item>
				<el-form-item>
					<el-button @click="editbatchdialogVisible = true">批量新增
					</el-button>
				</el-form-item>
				<!-- <el-form-item>
					<el-button type="primary" @click="downLoadTemp">下载模板
					</el-button>
				</el-form-item> -->
			</el-form>
			<el-table empty-text='暂无查询结果，换个关键词试试吧' :data="tableData" border class="table-wrap"
				:header-cell-style="{background:'#eef1f6',color:'#606266'}" @selection-change="handleChange">
				<el-table-column prop="uuid" label="用户ID" align="center">
				</el-table-column>
				<el-table-column prop="name" label="用户昵称" fit align="center">
				</el-table-column>
				<el-table-column prop="phone" label="用户手机号" fit align="center">
				</el-table-column>
				<el-table-column prop="business_name" label="用户企业" fit align="center">
					<template slot-scope="scope">
						{{scope.row.business_name?scope.row.business_name:'/'}}
					</template>
				</el-table-column>
				<el-table-column prop="member_name" label="用户会员等级" fit align="center">
				</el-table-column>
				<el-table-column prop="create_time" label="用户注册时间" fit align="center">
				</el-table-column>
				<el-table-column prop="disabled" label="用户状态" fit align="center">
					<template slot-scope="scope">
						{{scope.row.disabled==1?'启用':'禁用'}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="200px" align="center" fit>
					<template slot-scope="scope">
						<div class="operation-wrap">
							<span class="operation-item" @click="event().handleOperationClick(scope.row)">查看详情</span>
							<!-- <span class="operation-item" @click="editAdminClick(scope.row)">编辑</span> -->
							<span class="operation-item" style="color: #ff0000;" v-if="scope.row.disabled == 1"
								@click="UserDisabledClick(scope.row,2)">禁用</span>
							<span class="operation-item" v-if="scope.row.disabled == 2"
								@click="UserDisabledClick(scope.row,1)">解禁</span>
							<!-- <span class="operation-item" @click="resetPasswordClick(scope.row)">重置密码</span>
							<span class="operation-item" @click="editAdminClick(scope.row)">编辑</span> -->
							<!-- <span class="operation-item delete" @click="deleteClick(scope.row)">
								<i class="el-icon-delete"></i>删除</span> -->
						</div>
					</template>
				</el-table-column>
			</el-table>


			<common-dialog :titleType="titleType" :title="dialogTitle" :dialogVisible="dialogVisible"
				@cancel="dialogCancelClick" @confirm="dialogConfirmClick" @dialog-close="dialogClose">
				<div class="dialog-body-wrap">
					<div style="color: #ff0000;" v-if="dialogType ==='disabled' && titleType=='禁用'">
						禁用后当前用户将无法登录Web及小程序
					</div>
					<div style="color: #ff0000;" v-if="dialogType ==='disabled' && titleType=='启用'">
						启用后将恢复用户登录权限
					</div>
				</div>
			</common-dialog>


			<common-pagination :total="total" :page_size="page_size" :page_index="page_index"
				@page-change="handlePageChange" @size-change="handleSizeChange"></common-pagination>

			<UserDialog :uuid="selectForm" :dialogProp="editdialogVisible" @input="closeDialog"
				@confirm="confirmDialog">
			</UserDialog>

			<UserBatchDialog :dialogProp="editbatchdialogVisible" @input="closeDialog" @confirm="confirmDialog">
			</UserBatchDialog>
		</el-card>
	</div>
</template>

<script>
	import CommonDialog from "@/components/CommonDialog";
	import FileUploadVue from "../../../components/FileUpload.vue";
	import operations from "@/mixins/operations";
	import UserDialog from "./components/UserDialog.vue"
	import UserBatchDialog from "./components/UserBatchDialog.vue"
	import CommonPagination from "@/components/CommonPagination";
	import {
		getUserList,
		deleteUser,
		UserDisabled,
		getMemberList
	} from "@/api/user"
	import {
		mapState
	} from "vuex";
	import utils from "@/jslibs/utils"

	export default {
		name: "hotellist",
		mixins: [operations],
		data() {
			return {
				total: 0,
				page_size: 10,
				page_index: 1,
				tableData: [],
				selectedTabIndex: "1",
				dataForm: {
					name: "",
					disabled: '',
					member_name: '',
					registerTime: '',
					start_time: '',
					end_time: '',
					phone: '',
					member_uuid: []
				},
				showDialog: false,
				showDialogType: "Authentication",
				showDialogTitle: '',
				cancelBtnText: "",
				userAuthInfo: {},
				level: [],
				userStatuList: [{
						value: 1,
						label: '启用'
					},
					{
						value: 2,
						label: '禁用'
					}
				],
				allChioce: [],
				allSelectIdList: [],
				selectForm: {},
				editdialogVisible: false,
				//删除弹框开始
				dialogTitle: "",
				dialogType: "",
				dialogVisible: false,
				form: {},
				//删除弹框结束
				passwordShow: false,
				passwordForm: {},
				titleType: '',
				editbatchdialogVisible: false
			};
		},
		components: {
			CommonPagination,
			UserDialog,
			FileUploadVue,
			CommonDialog,
			UserBatchDialog
		},
		mounted() {
			this.getMemberList()
			this.network().getUserTableList();
		},
		computed: {
			...mapState(["imgDomain"])
		},
		methods: {
			async getMemberList() {
				const {
					data
				} = await getMemberList({
					page_index: 1,
					page_size: 999
				});
				this.level = data.result.data
			},
			changeTime(e) {
				this.dataForm.start_time = e[0]
				this.dataForm.end_time = e[1]
			},
			downLoadTemp() {
				window.location.href =
					'https://gymoo-project-cdn.oss-cn-shenzhen.aliyuncs.com/innovation/%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
			},
			resetPasswordClick(row) {
				this.passwordShow = true;
				this.passwordForm = row;
			},
			async UserDisabledClick(row, disabled) {
				this.form = JSON.parse(JSON.stringify(row));
				this.dialogVisible = true;
				this.dialogType = "disabled";
				this.dialogTitle = '当前用户吗？';
				this.titleType = disabled == 1 ? '启用' : '禁用'
			},
			//删除弹框开始
			dialogCancelClick: () => {
				this.dialogVisible = false
			},
			async dialogConfirmClick() {
				if (this.dialogType === "delete") {
					let postData = {
						uuid: this.form.uuid
					}
					const {
						status
					} = await deleteUser(postData);
					this.$message.success('删除成功')
					if (status === 200) {
						this.dialogVisible = false;
						return;
					}
				}
				if (this.dialogType === "disabled") {
					const {
						status
					} = await UserDisabled({
						uuid: this.form.uuid,
						disabled: this.titleType == '启用' ? 1 : 2
					});
					this.$message.success('操作成功')
					if (status === 200) {
						this.dialogVisible = false;
						this.network().getUserTableList();
					}
				}

			},
			dialogClose() {
				this.dialogVisible = false;
				this.network().getUserTableList();
			},
			deleteClick(row) {
				this.form = JSON.parse(JSON.stringify(row));
				this.dialogVisible = true;
				this.dialogType = "delete";
				this.dialogTitle = "删除用户";
			},
			//删除弹框结束
			closeDialog(row) {
				this.editbatchdialogVisible = false
				this.passwordShow = false
				this.editdialogVisible = false;
			},
			confirmDialog(row) {
				this.editdialogVisible = row;
				this.editbatchdialogVisible = false
				this.network().getUserTableList()
			},
			//添加
			addAdminClick() {
				this.selectForm = {};
				this.selectForm.role_uuid = this.uuid
				this.editdialogVisible = true;
			},
			//修改
			editAdminClick(row) {
				this.editdialogVisible = true;
				this.selectForm = row;
				this.selectForm.role_uuid = this.uuid
			},
			handleChange(row) {
				this.allSelectIdList = row.map(item => item.user_id);
			},
			tabChange(e) {
				this.dataForm.status = e
				this.network().getUserTableList();
			},
			/**文件上传选择完成时触发的事件函数**/
			onFileChange(e) {
				let file = e.target.file[0]
			},
			handlePageChange(page) {
				this.event().handlePageChange(page);
			},
			handleSizeChange(size) {
				this.event().handleSizeChange(size);
			},
			/**
			 *触摸，响应事件放在event下，如onclick函数,onchange函数等
			 *特殊情况:像一些需要接收参数的事件，如onchange原生事件或者是vue中的emit有参数的事件,必须得写在event外部，否则无法得到接收参数。像这种事件特殊处理
			 **/
			event() {
				return {
					clearSearch: () => {
						this.dataForm.name = ''
						this.dataForm.disabled = ''
						this.dataForm.member_name = ''
						this.dataForm.registerTime = ''
						this.dataForm.start_time = ''
						this.dataForm.end_time = ''
						this.dataForm.phone = ''
						this.dataForm.registerTime = ''
						this.dataForm.member_uuid = []
						this.page_index = 1
						this.network().getUserTableList();
					},
					handleClick: () => {
						this.network().getUserTableList();
					},
					toggleTab: (index) => {
						this.allChioce = [];
						this.dataForm.is_blacklist = index
						this.network().getUserTableList();
					},
					/**
					 * 点击全选
					 * @param {Object} index
					 */
					onAllChioceChange: (row) => {
						//全选将List中的id提取出来
						this.allSelectIdList = row.map(item => item.user_id);
					},
					/**
					 * 已认证用户点击
					 */
					onShowDialogClick: (btn, data) => {
						this.showDialog = true;
						this.showDialogType = btn;
						this.userAuthInfo = data;
						this.showDialogTitle = '认证信息';
						this.cancelBtnText = "返回"
					},
					onCloseModalClick: () => {
						this.showDialog = false;
					},
					/**
					 * 查看用户详情
					 */
					handleOperationClick: (data) => {
						this.$router.push({
							path: "/user-detail?uuid=" + data.uuid
						})
					},
					/**
					 * 解禁/禁用
					 * @param {Object} uuid
					 */
					handleIsDisableclick: (uuid, is_blacklist) => {
						// var uuidList = uuid.split(",");
						this.network().newWorkIsDisableClick(uuid, is_blacklist);
					},
					handlePageChange: (page) => {
						this.page_index = page;
						this.network().getUserTableList();
					},
					handleSizeChange: (size) => {
						this.page_size = size;
						this.network().getUserTableList();
					},
					onBatchApprovalClick: (isDisable) => {
						if (this.allSelectIdList.length > 0) {
							if (isDisable) { // true 解
								this.network().batchUnDisable()
							} else {
								this.network().batchDisable()
							}
						} else {
							this.$message.error('请点击全选选项');
						}
					},
				}
			},
			/**
			 *网络访问相关函数
			 **/
			network() {
				return {
					getUserTableList: async () => {

						let postData = {
							page_size: this.page_size,
							page_index: this.page_index,
							keyword_search: this.dataForm.key,
							disabled: this.dataForm.disabled,
							name: this.dataForm.name,
							member_uuid: this.dataForm.member_uuid.toString(),
							start_time: this.dataForm.start_time,
							end_time: this.dataForm.end_time,
							phone: this.dataForm.phone,
						};
						const {
							status,
							data
						} = await getUserList(postData);
						if (status !== 200) return;
						this.tableData = data.result.data;
						this.total = data.result.total;
					},

					batchDisable: async () => {
						let postData = {
							user_ids: this.allSelectIdList
						}
						const {
							status,
							data
						} = await batchDisable(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},
					batchUnDisable: async () => {
						let postData = {
							user_ids: this.allSelectIdList
						}
						const {
							status,
							data
						} = await batchUnDisable(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},


					disableUser: async (row) => {
						let postData = {
							user_id: row.user_id
						}
						const {
							status,
							data
						} = await disableUser(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},

					ableUser: async (row) => {
						let postData = {
							user_id: row.user_id
						}
						const {
							status,
							data
						} = await ableUser(postData);
						if (status !== 200) return;
						this.network().getUserTableList();
					},
				}
			},
			/**
			 * 一般放处理业务逻辑较多的私人函数
			 **/
			handler() {
				return {
					handleListA(list) {
						for (var i = 0; i < list.length; i++) {
							//handle service
						}
					},
					/**
					 **校验表单输入
					 **/
					verifyInput() {},

				}
			}

		}
	};
</script>

<style lang="less" scoped>
	@import "~@/assets/styles/variables.less";
	@import "~@/assets/styles/mixins.less";

	.table-wrap {
		.table-wrap(5px);
	}

	.m-content {
		width: 12rem;
	}

	.m-tab {
		position: relative;
		margin-bottom: 2.1875rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.m-tab-item {
		padding-right: 2.0625rem;
		color: #8D8EA6;
		font-size: 1.375rem;
		text-align: center;
	}

	.m-tab-item-active {
		color: #409eff;
	}

	.tab-line {
		height: 2px;
		background: #409eff;
		position: absolute;
		bottom: 0;
		transition: all 0.3s ease;
	}

	.tab-line-0 {
		width: 3rem;
		left: 0;
	}

	.tab-line-1 {
		width: 5rem;
		left: 1;
	}
</style>